module.exports = __webpack_public_path__ + "static/media/01s.d84ce10e.png";